import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { AirportsInfoService } from '../airports-info.service';
import { searchAirports, searchAirportsFailure, searchAirportsSuccess } from './airports-info-service.actions';

@Injectable()
export class AirportsInfoEffects {
  private readonly actions$ = inject(Actions);
  private readonly airportsInfoService = inject(AirportsInfoService);

  searchAirports$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchAirports),
      mergeMap(({ id, query }) =>
        this.airportsInfoService.searchAirports(query).pipe(
          map((airports) => searchAirportsSuccess({ id, airports, loading: false })),
          catchError((error) => of(searchAirportsFailure({ id, error: error.message })))
        )
      )
    )
  );
}
